import Devise from "@kaspernj/api-maker/build/devise"

/**
 * Whether the given ApiMaker current user is actually signed in and aligned with Devise's session — i.e. both
 * the cached user and Devise's user are present, the Devise session is signed in, and their ids match. Used
 * to avoid showing/loading signed-in-only UI (like the week bar) for a stale or anonymous user.
 *
 * @param {import("models/user").default | undefined | null} currentUser
 * @returns {boolean}
 */
const hasAlignedSignedInUser = (currentUser) => {
  const deviseCurrentUser = Devise.currentUser()

  return Boolean(
    currentUser?.id?.() &&
    deviseCurrentUser?.id?.() &&
    Devise.isUserSignedIn() &&
    currentUser.id() == deviseCurrentUser.id()
  )
}

export default hasAlignedSignedInUser
